import { PartRevisionCostCalculationLogApi } from "src/api/generated/erp/parts/sitePart/api/partRevisionCostCalculationLogApi";
import { PartRevisionCostCalculationLogView } from "src/api/generated/erp/db/types/tables/partRevisionCostCalculationLogView";
import { ClientSideDataGridModel } from "src/components/common/dataGrid/gridModel/ClientSideDataGridModel";
import { FormCrudDataGrid } from "src/components/common/dataGrid/crud/FormCrudDataGrid";
import { dateTimeColumn, floatColumn, textColumn } from "src/components/common/dataGrid/columns";
import i18n from "i18next";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface PartRevisionCostCalculationLogDataGridProps {
	partRevisionId: number;
}

export const PartRevisionCostCalculationLogDataGrid = ({
	partRevisionId,
}: PartRevisionCostCalculationLogDataGridProps) => {
	return (
		<ClientSideDataGridModel
			gridId={"A7F3E2D1B8C94E5F"}
			fetchData={() =>
				PartRevisionCostCalculationLogApi.getPartRevisionCostCalculationLogs({
					partRevisionId,
				})
			}
			getRows={(data) => data}
			getRowId={(row) => row.calculationId}
			initialParams={{}}
			render={({ dataGridProps }) => (
				<FormCrudDataGrid<PartRevisionCostCalculationLogView>
					columns={[
						dateTimeColumn({
							field: "createdAt",
							headerName: i18n.t("calculated_at"),
							width: 150,
						}),
						textColumn({
							field: "createdByUserName",
							headerName: i18n.t("calculated_by"),
							width: 150,
						}),
						floatColumn({
							field: "workCostResult",
							headerName: i18n.t("work_cost"),
							width: 120,
						}),
						floatColumn({
							field: "materialCostResult",
							headerName: i18n.t("material_cost"),
							width: 120,
						}),
						floatColumn({
							field: "previousWorkCostResult",
							headerName: i18n.t("previous_work_cost"),
							width: 150,
						}),
						floatColumn({
							field: "previousMaterialCostResult",
							headerName: i18n.t("previous_material_cost"),
							width: 150,
						}),
						dateTimeColumn({
							field: "updatedToPart",
							headerName: i18n.t("updated_to_part"),
							width: 150,
						}),
					]}
					agentContext={{
						key: defineAgentUiContextKey("erp.parts.partRevisionCostCalculationLog.grid"),
						data: { partRevisionId },
						rowFields: ["calculationId", "partRevisionId", "createdAt", "createdByUserId"],
						selectedRowPathSegment: (row) => `${i18n.t("calculated_at")} ${row.createdAt}`,
					}}
					{...dataGridProps}
				/>
			)}
		/>
	);
};
